import Swiper, { Scrollbar, Mousewheel, Lazy, Controller } from "swiper";
Swiper.use([Scrollbar, Mousewheel, Lazy, Controller]);

export default class SliderBuilding {
  constructor() {
    this.setupSliders = this.setupSliders.bind(this);
  }

  init() {
    this.setupSliders();

    this.events();
  }

  setupSliders() {
    this.sliderMain = new Swiper(".js-slider-main", {
      loop: false,
      lazy: true,
      watchSlidesVisibility: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: "auto",
          // spaceBetween: 50,
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: "auto",
          // spaceBetween: 40,
        },
      },
      containerModifierClass: "c-slider-main-",
      slideClass: "c-slider-main__slide",
      slideActiveClass: "-active",
      slideVisibleClass: "-visible",
      slideNextClass: "-next",
      slidePrevClass: "-prev",
      wrapperClass: "c-slider-main__wrapper",
    });

    this.sliderContent = new Swiper(".js-slider-content", {
      loop: false,
      lazy: true,
      watchSlidesVisibility: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: "auto",
          // spaceBetween: 50,
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: "auto",
          centeredSlides: true,
        },
      },
      scrollbar: {
        el: ".js-carousel-scrollbar-building",
        hide: false,
      },
      containerModifierClass: "c-slider-content-",
      slideClass: "c-slider-content__slide",
      slideActiveClass: "-active",
      slideVisibleClass: "-visible",
      slideNextClass: "-next",
      slidePrevClass: "-prev",
      wrapperClass: "c-slider-content__wrapper",
    });
  }

  events() {
    if (this.sliderMain && this.sliderMain.controller) {
      this.sliderMain.controller.control = this.sliderContent;
      this.sliderContent.controller.control = this.sliderMain;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/sliderBuilding.js